import { testPlatform } from './internal/testPlatform';

export function isMac() {
  return testPlatform(/^Mac/i);
}
